"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isArticleRef = void 0;
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const isArticleRef = (u) => {
    var _a, _b;
    if (!u || typeof u !== 'object')
        return false;
    const possibleArticleRef = u;
    // neither DE nor US is present?
    if (!echain_shared_ts_utils_1.StringUtils.isNonEmptyString((_a = possibleArticleRef.ArtNr) === null || _a === void 0 ? void 0 : _a['DE']) &&
        !echain_shared_ts_utils_1.StringUtils.isNonEmptyString((_b = possibleArticleRef.ArtNr) === null || _b === void 0 ? void 0 : _b['US'])) {
        return false;
    }
    return (echain_shared_ts_utils_1.StringUtils.isNonEmptyString(possibleArticleRef.EchainId) &&
        echain_shared_ts_utils_1.StringUtils.isNullishOrNonEmptyString(possibleArticleRef.AkeneoSku) &&
        echain_shared_ts_utils_1.StringUtils.isNullishOrNonEmptyString(possibleArticleRef.AkeneoUuid) &&
        echain_shared_ts_utils_1.NumberUtils.isNullishOrDefinedNumber(possibleArticleRef.IproId));
};
exports.isArticleRef = isArticleRef;
//# sourceMappingURL=ArticleRef.js.map